<template>
    <div>
        <el-table :data="sheetToImport" border style="width: 100%" empty-text="沒有資料" height="300px">
            <el-table-column type="index" label="#" width="50" fixed></el-table-column>
            <el-table-column label="匯入狀態" show-overflow-tooltip prop="status" width="100" fixed>
                <template slot-scope="scope">
                    <span :class="getImportStatus(scope.row.importStatus)"> {{ getImportMsg(scope.row.importStatus) }}</span>
                </template>
            </el-table-column>
            <el-table-column :label="clMap.fnam" :prop="clMap.fnam" show-overflow-tooltip width="150" />
            <el-table-column :label="clMap.bsn" :prop="clMap.bsn" width="140" />
            <el-table-column :label="clMap.adr" show-overflow-tooltip :prop="clMap.adr" width="250" />
            <el-table-column :label="clMap.bilL_DAY" :prop="clMap.bilL_DAY" width="80" />
            <el-table-column :label="clMap.soO_DAY" :prop="clMap.soO_DAY" width="80" />
            <el-table-column :label="clMap.note" :prop="clMap.note" width="250" />
            <el-table-column :label="clMap.accountLast5Number" :prop="clMap.accountLast5Number" width="120" />
            <el-table-column :label="clMap.nam" :prop="clMap.nam" width="120" />
            <el-table-column :label="clMap.gen" :prop="clMap.gen" width="80" />
            <el-table-column :label="clMap.job" :prop="clMap.job" width="100" />
            <el-table-column :label="clMap.tel" :prop="clMap.tel" width="130" />
            <el-table-column :label="clMap.ext" :prop="clMap.ext" width="80" />
            <el-table-column :label="clMap.eml" :prop="clMap.eml" width="180" />
        </el-table>
    </div>
</template>

<script>
import clMap from '@/components/dashboard/Vendor/BatchImportDialogViews/labelFieldMap';

export default {
    props: {
        sheetToImport: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        clMap() {
            return clMap;
        },
    },
    methods: {
        getImportMsg(importStatus) {
            switch (importStatus) {
            case 'init':
                return '---';
            case 'importing':
                return '匯入中...';
            default:
                return importStatus;
            }
        },
        getImportStatus(importStatus) {
            switch (importStatus) {
            case '已新增':
                return 'success';
            case 'init':
            case 'importing':
                return '';
            default:
                return 'error';
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.success {
    color: #44bf00;
    &::before {
        content: "Ｏ";
    }
}
.error {
    color: red;
    &::before {
        content: "Ｘ";
    }
}
</style>
